(() => {
  const storageKey = 'jskis_livechat_finder';
  let finder = {};
  let timer;
  let delay = 250;
  let readyWidget;
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    if (saved && typeof saved === 'object' && !Array.isArray(saved)) finder = saved;
  } catch { /* Storage may be unavailable. */ }

  function sync() {
    clearTimeout(timer);
    const widget = window.LiveChatWidget;
    if (widget && typeof widget.call === 'function') {
      if (readyWidget !== widget && typeof widget.once === 'function') {
        readyWidget = widget;
        widget.once('ready', sync);
      }
      // Merge so app-provided variables and ski finder answers stay intact.
      widget.call('update_session_variables', {
        ...finder,
        ski_page: window.jSkisLiveChatPage || 'no',
      });
    } else {
      // App embeds can appear after consent or a long load; keep waiting.
      timer = setTimeout(sync, delay);
      delay = Math.min(delay * 2, 5000);
    }
  }

  window.jSkisUpdateLiveChatFinder = (variables) => {
    finder = variables;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(finder));
    } catch { /* Continue sending even when storage is unavailable. */ }
    delay = 250;
    sync();
  };
  window.addEventListener('pageshow', sync);
  window.addEventListener('pagehide', () => clearTimeout(timer));
  sync();
})();
